import { request } from './http';

export async function getAuditScopes(filters = {}) {
    const queryParams = new URLSearchParams();
    if (filters.CompanyID) queryParams.append('CompanyID', filters.CompanyID);
    if (filters.Active !== undefined) queryParams.append('Active', filters.Active);
    const queryString = queryParams.toString();
    return request(`/verifications/audit-scopes${queryString ? '?' + queryString : ''}`);
  }

export async function getAuditScope(id) {
    return request(`/verifications/audit-scopes/${id}`);
  }

export async function createAuditScope(scopeData) {
    return request('/verifications/audit-scopes', {
      method: 'POST',
      body: JSON.stringify(scopeData),
    });
  }

export async function updateAuditScope(id, scopeData) {
    return request(`/verifications/audit-scopes/${id}`, {
      method: 'PUT',
      body: JSON.stringify(scopeData),
    });
  }

export async function deleteAuditScope(id) {
    return request(`/verifications/audit-scopes/${id}`, {
      method: 'DELETE',
    });
  }

export async function generateQuestionnairesFromScope(scopeId, year, siteIds = null) {
    const body = { year };
    if (siteIds != null && Array.isArray(siteIds) && siteIds.length > 0) body.siteIds = siteIds;
    return request(`/verifications/audit-scopes/${scopeId}/generate-questionnaires`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

export async function checkNewQuestionsAfterCompletion(scopeId, year) {
    return request(`/verifications/audit-scopes/${scopeId}/check-new-questions`, {
      method: 'POST',
      body: JSON.stringify({ currentYear: year }),
    });
  }

export async function createVerificationsForNewQuestion(scopeId, questionId, siteIds, year, dueDate, raci) {
    return request(`/verifications/audit-scopes/${scopeId}/questions/${questionId}/create-verifications`, {
      method: 'POST',
      body: JSON.stringify({ year, dueDate, raci }),
    });
  }

export async function getAuditScopeRegulations(scopeId) {
    return request(`/verifications/audit-scopes/${scopeId}/regulations`);
  }

export async function getQuestionBanks(filters = {}) {
    return getAuditScopes(filters);
  }

export async function getQuestionBank(id) {
    return getAuditScope(id);
  }

export async function createQuestionBank(bankData) {
    return createAuditScope(bankData);
  }

export async function updateQuestionBank(id, bankData) {
    return updateAuditScope(id, bankData);
  }

export async function deleteQuestionBank(id) {
    return deleteAuditScope(id);
  }

export async function generateQuestionnairesFromBank(bankId, year) {
    return generateQuestionnairesFromScope(bankId, year);
  }

export async function getQuestionBankRegulations(bankId) {
    return getAuditScopeRegulations(bankId);
  }

export const auditScopesApi = {
  getAuditScopes,
  getAuditScope,
  createAuditScope,
  updateAuditScope,
  deleteAuditScope,
  generateQuestionnairesFromScope,
  checkNewQuestionsAfterCompletion,
  createVerificationsForNewQuestion,
  getAuditScopeRegulations,
  getQuestionBanks,
  getQuestionBank,
  createQuestionBank,
  updateQuestionBank,
  deleteQuestionBank,
  generateQuestionnairesFromBank,
  getQuestionBankRegulations,
};

